export default function Card({ title, children }) {
  return (
    <div className="rounded-2xl border bg-white p-3 sm:p-4 shadow-sm">
      <h3 className="text-sm font-semibold" style={{ color: "#0A3E91" }}>{title}</h3>
      <div className="mt-2 sm:mt-3 space-y-3">{children}</div>
    </div>
  );
}